import { useState, type JSX } from 'react';
import { Dialog } from '../../components/Dialog';
import type { DialogSpec } from '../../uiStore';

type PromptSpec = Extract<DialogSpec, { type: 'prompt' }>;
type ConfirmSpec = Extract<DialogSpec, { type: 'confirm' }>;

export function PromptDialog({ spec, onClose }: { spec: PromptSpec; onClose(): void }): JSX.Element {
  const [value, setValue] = useState(spec.initial);
  const valid = value.trim().length > 0;
  const submit = (): void => {
    if (!valid) return;
    onClose();
    spec.onSubmit(value.trim());
  };
  return (
    <Dialog
      title={spec.title}
      onClose={onClose}
      width={380}
      footer={
        <>
          <button type="button" className="ui-btn" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="ui-btn primary" disabled={!valid} onClick={submit}>
            {spec.confirmLabel ?? 'OK'}
          </button>
        </>
      }
    >
      <form
        className="ui-col"
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <label htmlFor="prompt-input" className="ui-dim">
          {spec.label}
        </label>
        <input
          id="prompt-input"
          data-autofocus
          className="ui-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={(e) => e.currentTarget.select()}
        />
      </form>
    </Dialog>
  );
}

export function ConfirmDialog({ spec, onClose }: { spec: ConfirmSpec; onClose(): void }): JSX.Element {
  return (
    <Dialog
      title={spec.title}
      onClose={onClose}
      width={420}
      footer={
        <>
          <button type="button" className="ui-btn" data-autofocus onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={spec.danger ? 'ui-btn danger' : 'ui-btn primary'}
            onClick={() => {
              onClose();
              spec.onConfirm();
            }}
          >
            {spec.confirmLabel ?? 'OK'}
          </button>
        </>
      }
    >
      <p style={{ margin: 0 }}>{spec.message}</p>
    </Dialog>
  );
}
